import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

const ConfiguratorContext = /*#__PURE__*/ React.createContext(null);
const useConfiguratorContext = ()=>{
    const context = React.useContext(ConfiguratorContext);
    if (context === null) {
        throw Error(`Consumer of useConfiguratorContext needs to be wrapped in a ConfiguratorContext provider.`);
    }
    return context;
};
var ConfiguratorContextProvider = (_param)=> {
    var { children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children"
    ]);
    return React.createElement(ConfiguratorContext.Provider, {
        value: rest
    }, children);
};

export { ConfiguratorContext, ConfiguratorContextProvider, useConfiguratorContext };
//# sourceMappingURL=ConfiguratorContext.js.map
